import {Routes} from '@angular/router';
import {PERMISSION} from '@generated-backend-types';
import {CanActivateGuard} from '../../guards/can-activate.guard';
import {ServiceProviderBudgetsService} from '../../services/service-provider-budgets/service-provider-budgets.service';

const PERMISSIONS = [PERMISSION.SPH_RESOURCES_SERVICEPROVIDER_SERVICEPROVIDERBUDGET_READ_ALL];
const BUDGETS_BREADCRUMB = {label: 'budgets.breadcrumb', translate: true, route: '/budgets'};

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./service-provider-budgets-index/service-provider-budgets-index.component')
      .then(m => m.ServiceProviderBudgetsIndexComponent),
    canActivate: [CanActivateGuard],
    data: {breadcrumb: [BUDGETS_BREADCRUMB], allPermissionsNeeded: PERMISSIONS},
  },
  {
    path: ':id',
    loadComponent: () => import('./service-provider-budget-detail/service-provider-budget-detail.component')
      .then(m => m.ServiceProviderBudgetDetailComponent),
    canActivate: [CanActivateGuard],
    resolve: {serviceProviderBudget: ServiceProviderBudgetsService},
    data: {
      breadcrumb: [
        BUDGETS_BREADCRUMB,
        {dynamic: true, dataKey: 'serviceProviderBudget.ext_budget_id'},
      ],
      allPermissionsNeeded: PERMISSIONS,
    },
  },
];
